import STATES from '../resources/js/states';

const rules = {
  required: value => (!!value || value === 0) || 'This field is required',
  notNull: value => value !== null || 'This field is required',
  min: n => value => (!!value && value.length >= n) || `Please enter at least ${n} characters`,
  max: n => value => (!!value && value.length <= n) || `Please enter up to ${n} characters`,
  equalLenght: n => value => (!!value && value.length === n) || `${n} characters required`,
  same: (n, m) => () => n === m || 'Not a match',
  email: value => {
    // eslint-disable-next-line max-len
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(value) || 'Please enter a valid e-mail';
  },
  phone: value => {
    const pattern = /^\(\d{3}\) \d{3}-\d{4}$/g;
    const reg = new RegExp(pattern);
    return reg.test(value) || 'Invalid format: please use (XXX) XXX-XXXX';
  },
  ssn: value => {
    const pattern = /^(\d{3}-\d{2}-\d{4})$/g;
    const reg = new RegExp(pattern);
    return reg.test(value) || 'Invalid format: please use XXX-XX-XXXX';
  },
  zip: value => {
    const pattern = /^(\d{5}(-\d{4})?)$/g;
    const reg = new RegExp(pattern);
    return reg.test(value) || 'Invalid format: please use XXXXX or XXXXX-XXXX';
  },
  state: value => STATES.includes(value) || 'Invalid state',

  // Helper function to make a certain rule optional
  optional: func => value => (value ? func(value) : true),
  specialCharacteresNotAllowed: value => {
    const pattern = /^[a-zA-Z0-9._,:/-\s]*$/g;
    const re = new RegExp(pattern);
    return re.test(value) || 'Special characteres are not allowed';
  },
};

export default rules;
